/* eslint-disable camelcase */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export class StatisticApiConverter {
  convertStatistic = ({ general, users, transfers, bets }) => ({
    general: {
      balance: general.balance,
      incomeToday: general.income_today,
    },
    users: {
      totalPlayers: users.total_players,
      totalCashiers: users.total_cashiers,
      totalAdmins: users.total_admins,
      playersRegisteredToday: users.players_registered_today,
    },
    transfers: {
      depositsSum: transfers.deposits_sum,
      withdrawalsSum: transfers.withdrawals_sum,
      total: transfers.total,
      depositsCount: transfers.deposits_count,
      withdrawalsCount: transfers.withdrawals_count,
    },
    bets: {
      totalBetAmount: bets.total_bet_amount,
      totalWinnings: bets.total_winnings,
      totalGgr: bets.total_ggr,
      totalBetsCount: bets.total_bets_count,
    },
  });
}
